import WagesTestParamsEditPage from './WagesTestParamsEditPage';

export default WagesTestParamsEditPage;